module.exports = __webpack_public_path__ + "img/product-preview-74.75115a0.png";